import React from 'react';
import Popup from './components/Popup/popup'
import Login from './components/Login/login'
import { ApolloProvider } from '@apollo/react-hooks'
import client from './Apollo'
import AuthenticationProvider, { useAuthentication } from 'hooks/authentication'
// import Background from './components/Background/background'

// import useAuthentication from './providers/authentication'

// import {
//   BrowserRouter as Router,
//   Switch,
//   Route
// } from 'react-router-dom';

// class App extends Component {
//   render() {
//     return (
//       <ApolloProvider client={client}>
//         {/* <Background /> */}
//         <Router>
//           <Switch>
//             <Route exact path="/" component={Login} />
//             <Route exact path="/dashboard" component={Popup} />
//           </Switch>
//         </Router>
//       </ApolloProvider>
//     );
//   }
// }

function App() {

  return (
    <ApolloProvider client={client}>
      <AuthenticationProvider>      
        <Test />
      </AuthenticationProvider>      
    </ApolloProvider>
  )
}

function Test() {
  const { isAuthenticated } = useAuthentication()
  return isAuthenticated ? <Popup /> : <Login />
}

export default App;
